import template from './other-direct-costs-details.html';
import controller from './other-direct-costs-details.controller';

let otherDirectCostsDetailsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default otherDirectCostsDetailsComponent;



// WEBPACK FOOTER //
// ./client/pages/expenses/other-direct-costs-details/other-direct-costs-details.component.js